import React from 'react';

function Morocco(props) {
  return (
    <svg
      {...props}
      width="36"
      height="24"
      viewBox="0 0 36 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_800_124066)">
        <mask
          id="mask0_800_124066"
             style={{ maskType: 'luminance' }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="36"
          height="24"
        >
          <rect width="36" height="24" fill="white" />
        </mask>
        <g mask="url(#mask0_800_124066)">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0 0H36V22C36 23.1046 35.1046 24 34 24H2C0.895431 24 0 23.1046 0 22V0Z"
            fill="#C51918"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0 0H36V24H0V0Z"
            fill="#E31D1C"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M25.2921 19.6262L18.1865 2.70059H17.8782L11.0195 19.6262L18.1423 15.821L25.2921 19.6262ZM17.4 8.22201L18.1617 5.58366L18.9522 8.29758L21.2232 13.9541L22.5566 16.6926L19.678 14.8899L18.1407 14.0718L16.6283 14.8798L13.8165 16.6926L15.1164 13.898L17.4 8.22201Z"
            fill="#579D20"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M14.2453 13.4731L18.1782 15.7971L21.8482 13.4731L28.8184 8.23643H7.18335L14.2453 13.4731ZM14.3269 11.4741L11.6521 10.0191H14.9154H21.3996H24.2782L21.9821 11.3119L18.1611 13.8888L14.3269 11.4741Z"
            fill="#579D20"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_800_124066">
          <rect width="36" height="24" rx="5" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default Morocco;
